"use client";

import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ScrollableFlowScreen } from "../UI/ScrollableFlowScreen";
import { DesktopControlDemo } from "../Demos/DeepActionFlow/InteractionDemos/DesktopControlDemo";
import Image from "next/image";

interface ComputerUseSectionProps {
  onDownloadClick?: () => void;
}

export function ComputerUseSection({ onDownloadClick }: ComputerUseSectionProps) {
  const desktopRef = useRef<HTMLDivElement>(null);

  // Use the demo container ref for text scroll progress to ensure perfect sync
  const { scrollYProgress } = useScroll({
    target: desktopRef,
    offset: ["start center", "end end"],
  });

  const computerTexts = [
    "Computer Use transforms Fellou into a true system-level agent. Grant this AI Browser permission to operate local apps and manage files, giving you full control over a truly agentic workflow.",
  ];

  // 第二阶段"Still switching..." 文本显示 (0.7-1.0, 占总进度30%)
  const stillTextOpacity = useTransform(scrollYProgress, [0.7, 0.75, 0.9, 1.0], [0, 1, 1, 1]);

  return (
    <div>
      <ScrollableFlowScreen ref={desktopRef} onViewportEnter={() => console.log("Computer Use entered")} compact={true}>
        <div className="flex min-h-[400vh]">
          {/* Left Half - Progressive Text Display */}
          <div className="w-1/2 flex justify-center items-center px-8 sticky top-0 h-screen">
            <motion.div className="max-w-[600px] space-y-12">
              <h2 className="text-4xl font-bold text-white mb-8 w-full">
                <div className="w-full">Handles Desktop Files, </div> Zero Effort
              </h2>
              {computerTexts.map((text, index) => (
                <div key={index} className="text-2xl font-medium text-white leading-relaxed">
                  {text}
                </div>
              ))}

              {/* Still Text - 第二阶段文本显示 (0.5-1.0) */}
              <motion.div className="space-y-8" style={{ opacity: stillTextOpacity }}>
                <div className="text-3xl font-bold text-white/90 leading-tight">
                  <div className="flex items-center gap-2 relative mb-4">Still switching apps on AI&apos;s orders?</div>
                  <div className="flex items-center gap-2">
                    <div className="relative flex-shrink-0 size-8">
                      <Image
                        src="/favicon.ico"
                        alt="fellou"
                        fill
                        priority
                        unoptimized
                        className="rounded p-0.5 ring-1 ring-white/20"
                      />
                    </div>
                    <div>Fellou runs the whole system easily.</div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>

          {/* Right Half - Desktop Control Wireframe (Sticky) */}
          <div className="w-1/2 flex justify-center items-center px-8 sticky top-0 h-screen">
            <DesktopControlDemo controlRef={desktopRef} onDownloadClick={onDownloadClick} />
          </div>
        </div>
      </ScrollableFlowScreen>
    </div>
  );
}
